module.exports = __webpack_public_path__ + "img/house-crack.e412ac5c.svg";